export const callDemos = [
  {
    id: 1,
    color: 'teal',
    title: 'Requesting a move-out cleaning service.',
    duration: '1:12'
  },
  {
    id: 2,
    color: 'blue',
    title: 'Scheduling a haircut appointment.',
    duration: '0:55'
  },
  {
    id: 3,
    color: 'orange',
    title: 'Requesting a hot tub cleaning quote.',
    duration: '1:30'
  },
  {
    id: 4,
    color: 'purple',
    title: 'Advice on the best way to pay HOA fees.',
    duration: '1:38'
  }
];

export const videoTestimonials = [
  {
    id: 1,
    name: 'Derek Goodson',
    title: 'Founder',
    company: 'Sparkle Clean Co.',
    industry: 'Cleaning Service',
    rating: 5,
    quote: "Before Miadesk, we were losing 30% of our leads to missed calls during jobs. Now every call gets answered professionally and I get a text summary within seconds. Last month alone, Mia booked 47 new cleaning appointments while my team was out on sites. It's like having a full-time receptionist for a fraction of the cost."
  },
  {
    id: 2,
    name: 'Lisa Lewis Yates',
    title: 'CEO',
    company: 'Bright Smile Dental',
    industry: 'Dental Office',
    rating: 5,
    quote: "Handling calls before Miadesk was a waste of time. So many spam calls coming through that our patients couldn't get through. We didn't even want to pick up the phone anymore. Now we know every call is real — Mia filters out the junk and our patients love how quickly they can book appointments. Our no-show rate dropped 25% thanks to the automated reminders."
  },
  {
    id: 3,
    name: 'Ron Michaels',
    title: 'Managing Partner',
    company: 'Michaels & Associates Law',
    industry: 'Law Firm',
    rating: 5,
    quote: "In our practice, every missed call is a potential client walking to a competitor. Miadesk captures caller information, understands the nature of their legal issue, and routes urgent matters to me directly. The call transcripts are invaluable for our intake process. We've seen a 40% increase in qualified consultations since switching."
  },
  {
    id: 4,
    name: 'Tom Calhoun',
    title: 'Broker',
    company: 'Calhoun Realty Group',
    industry: 'Real Estate',
    rating: 5,
    quote: "Real estate is all about being available 24/7, but I can't answer every call during showings. Mia handles inquiries about listings, captures buyer info, and even schedules viewings through our calendar. My agents love it. We closed three extra deals last quarter just from calls Mia caught after hours."
  },
  {
    id: 5,
    name: 'Priya Sharma',
    title: 'Owner',
    company: 'Luxe Hair Studio',
    industry: 'Salon',
    rating: 4,
    quote: "My stylists used to stop mid-appointment to answer the phone. It was unprofessional and frustrating for clients in the chair. Miadesk changed everything — bookings come in smoothly, cancellations get handled, and our front desk runs itself. The bilingual support is a game-changer for our diverse clientele."
  },
  {
    id: 6,
    name: 'Marcus Rivera',
    title: 'Owner',
    company: 'Rivera HVAC Solutions',
    industry: 'HVAC',
    rating: 5,
    quote: "During summer, we'd get 50+ calls a day and miss half of them. Miadesk handles the overflow perfectly — takes down the issue, gets the address, and even gives basic troubleshooting advice from our FAQ list. My dispatchers can focus on scheduling instead of answering phones all day. Best investment I've made this year."
  }
];

// All actual Miadesk features — organized into platform sections
export const features = [
  // Core AI Agent
  {
    id: 1,
    icon: 'phone',
    title: 'AI Receptionist',
    description: 'AI-powered 24/7 call answering trained on your business. Handles inquiries, books appointments, captures leads, and transfers urgent calls — all in a natural, human-like voice.',
    category: 'core'
  },
  {
    id: 2,
    icon: 'brain',
    title: 'Business-Specific Training',
    description: 'Train your AI agent on your website, Google profile, and FAQs so it can accurately answer questions specific to your company.',
    category: 'core'
  },
  {
    id: 3,
    icon: 'shield',
    title: 'Spam & Telemarketing Filtering',
    description: 'Intelligently identifies and filters out spam, telemarketing, and unwanted solicitation calls, saving you time and frustration.',
    category: 'core'
  },
  {
    id: 4,
    icon: 'mic',
    title: 'Multilingual Support',
    description: 'Your AI agent speaks 10+ languages fluently, creating a familiar and comfortable experience for every caller and chat visitor.',
    category: 'core'
  },
  // Central AI Agent
  {
    id: 19,
    icon: 'message',
    title: 'Chat Agent',
    description: 'Embeddable AI chat widget for your website that qualifies leads, captures contact info, answers questions, and tracks marketing data — all in real time.',
    category: 'agent'
  },
  {
    id: 20,
    icon: 'phoneCall',
    title: 'Inbound Call AI',
    description: 'AI-powered inbound call handling with auto-qualify, intent analysis, sentiment scoring, spam filtering, call recording, and smart forwarding rules.',
    category: 'agent'
  },
  {
    id: 21,
    icon: 'megaphone',
    title: 'Outbound Campaigns',
    description: 'AI-generated outreach campaigns with multi-step sequences, script generation, contact enrollment, and performance tracking.',
    category: 'agent'
  },
  // Communication & Calls
  {
    id: 5,
    icon: 'phoneForwarded',
    title: 'Call Forwarding',
    description: 'Comprehensive setup guides for 25+ phone carriers with activation and deactivation codes. Forward calls to Miadesk from any provider.',
    category: 'communication'
  },
  {
    id: 6,
    icon: 'headphones',
    title: 'Call History & Recordings',
    description: 'Full call logs with AI-generated summaries, transcripts, intent analysis, sentiment scoring, and lead data extraction for every conversation.',
    category: 'communication'
  },
  {
    id: 7,
    icon: 'phoneCall',
    title: 'Dedicated Phone Numbers',
    description: 'Get a dedicated business phone number included with your subscription. Search by area code and activate instantly — powered by Twilio.',
    category: 'communication'
  },
  {
    id: 8,
    icon: 'transfer',
    title: 'Call Transfers',
    description: 'Seamlessly transfer important calls to your team members with warm transfers, ensuring urgent matters are handled promptly.',
    category: 'communication'
  },
  // Sales & CRM
  {
    id: 9,
    icon: 'users',
    title: 'Built-in CRM',
    description: 'Manage contacts, track leads through your pipeline, auto-capture caller info, and bulk import via CSV/XLSX. Full contact lifecycle management.',
    category: 'sales'
  },
  {
    id: 10,
    icon: 'megaphone',
    title: 'Sales Outreach',
    description: 'Create and manage multi-channel sales campaigns with AI-powered email/call sequences, prospect tracking, and promo campaign templates.',
    category: 'sales'
  },
  // Invoicing & Payments
  {
    id: 11,
    icon: 'invoice',
    title: 'Professional Invoicing',
    description: 'Create, customize, and send professional invoices with 4 templates, accent colors, line items, tax, discounts, and PDF generation. Send via email, SMS, or WhatsApp.',
    category: 'invoicing'
  },
  {
    id: 12,
    icon: 'package',
    title: 'Products & Services Catalog',
    description: 'Manage a catalog of your products and services with pricing, categories, and units. Quick-add items to invoices from your catalog.',
    category: 'invoicing'
  },
  {
    id: 13,
    icon: 'repeat',
    title: 'Recurring Invoices',
    description: 'Set up automatic recurring invoices on weekly, monthly, quarterly, or yearly schedules. Invoice generation runs hands-free.',
    category: 'invoicing'
  },
  {
    id: 14,
    icon: 'creditCard',
    title: 'Payment Tracking & Settings',
    description: 'Record and track payments against invoices. Configure bank account details and payment links that auto-fill into every new invoice.',
    category: 'invoicing'
  },
  // Analytics & Support
  {
    id: 15,
    icon: 'barChart',
    title: 'Conversation Insights',
    description: 'Dashboard with aggregate call analytics — common questions, sentiment trends, intent analysis, peak hours, and conversion tracking.',
    category: 'analytics'
  },
  {
    id: 16,
    icon: 'ticket',
    title: 'AI Ticketing System',
    description: 'Automatically generate support tickets from call conversations. Manage, prioritize, and resolve tickets with full call context attached.',
    category: 'analytics'
  },
  // Management
  {
    id: 17,
    icon: 'help',
    title: 'FAQ Manager',
    description: 'Train your AI with custom frequently asked questions. Miadesk learns your business-specific answers for consistent, accurate responses.',
    category: 'management'
  },
  {
    id: 18,
    icon: 'team',
    title: 'Team Management',
    description: 'Invite team members, assign roles, and manage access. Collaborate across your organization with shared business profiles.',
    category: 'management'
  },
];

export const setupSteps = [
  {
    step: 1,
    title: 'Train Mia on your business',
    description: 'Website, Google profile, FAQs'
  },
  {
    step: 2,
    title: 'Choose an agent name & greeting',
    description: 'Make it your own'
  },
  {
    step: 3,
    title: 'Forward calls to Mia',
    description: '24/7 coverage starts now'
  }
];
